import ContractSectionLayout from "./ContractSectionLayout";
export default ContractSectionLayout;
